import { createContext, useState, useMemo } from "react";
import { getData } from "../components/utilities/UtilityFunctions";

export const ImageCacheContext = createContext(null);

export const ImageCacheProvider = ({ children }) => {
  const [imageCache] = useState({});

  const fetchImage = async (fileId, size) => {
    if (!fileId) return;

    if (!imageCache[size || 0]) {
      imageCache[size || 0] = {};
    }
    if (imageCache[size || 0][fileId]) {
      if (imageCache[size || 0][fileId].expires + 2000 > Date.now()) {
        return imageCache[size || 0][fileId];
      }
    }

    var returnObj;
    try {
      returnObj = await getData(`/files/${fileId}`, {
        queryStringParameters: {
          size: size,
        },
      });

      let url = new URL(returnObj.url);
      let expires = url.searchParams.get("Expires");
      returnObj.expires = expires * 1000;

      imageCache[size || 0][fileId] = returnObj;
    } catch (err) {
      console.error(err);
    }

    return returnObj;
  };

  const vals = useMemo(
    () => ({
      imageCache,
      fetchImage,
    }),
    // eslint-disable-next-line
    [imageCache]
  );

  return (
    <ImageCacheContext.Provider value={vals}>
      {children}
    </ImageCacheContext.Provider>
  );
};
